import { create } from "zustand";

interface SelectedPointsStore {
  selectedPoints: any[];
  _userId: number | null;
  setSelectedPoints: (points: any[]) => void;
  clearSelectedPoints: () => void;
  initForUser: (userId: number) => void;
}

export const useSelectedPointsStore = create<SelectedPointsStore>((set, get) => ({
  // Deliberately memory-only. Persisting client-selected contact snapshots
  // across page reloads is unsafe: they cannot be re-proven to belong to the
  // active user and map before a dialer consumes them.
  selectedPoints: [],
  _userId: null,
  setSelectedPoints: (points) => {
    set({ selectedPoints: points });
  },
  clearSelectedPoints: () => {
    set({ selectedPoints: [] });
  },
  initForUser: (userId: number) => {
    // Always discard any prior session selection. A user must explicitly
    // select contacts from the currently loaded map in this browser session.
    if (get()._userId !== userId) set({ _userId: userId, selectedPoints: [] });
  },
}));
